module.exports = __webpack_public_path__ + "static/product-bigbarters-home-c2896b131bb25ce2d06320677ad3ecc3.png";